export default __webpack_public_path__ + "static/media/Vanderbilt.8ac25352.png";